// HOOKS
import { useEffect, useState } from "react";
// ICONS
import { ReactComponent as LeftArrowIcon } from "./assets/leftArrow.icon.svg";
import { ReactComponent as RightArrowIcon } from "./assets/rightArrow.icon.svg";
// UTILS
import { getPageList } from "./utils/getPageList";

const DEFAULT_CLASSNAMES = {
  container: "flex flex-row flex-nowrap items-center gap-1",
  arrow:
    "hover:fill-white active:shadow-inner active:shadow-black bg-lightPrimary hover:bg-lightSecondary shadow shadow-black hover:cursor-pointer hover:dark:bg-darkSecondary dark:bg-darkPrimary dark:fill-white rounded-md w-8 h-8",
  currentPage:
    "shadow-inner shadow-black dark:bg-darkSecondary bg-lightSecondary dark:text-white text-black hover:cursor-pointer rounded h-8 w-8 flex items-center justify-center",
  page: "active:shadow-inner active:shadow-black shadow shadow-black hover:dark:bg-darkSecondary hover:bg-lightSecondary active:shadow-inner dark:text-white text-black dark:bg-darkPrimary bg-lightPrimary hover:cursor-pointer rounded h-8 w-8 flex items-center justify-center",
};

const PaginationBar = ({
  currentPage = 1,
  totalPages = 1,
  maxDifference = 3,
  showEllipsis = false,
  handleChange = () => {},
  classNames = DEFAULT_CLASSNAMES,
}) => {
  const [pages, setPages] = useState([1]);
  // Adjust currentPage if it exceeds totalPages
  useEffect(() => {
    if (currentPage > totalPages) handleChange(totalPages);
  }, [totalPages]);
  // Set pages on mount
  useEffect(() => {
    if (!(totalPages > 1)) return setPages([1]);
    setPages(
      getPageList({
        currentPage,
        maxPages: totalPages,
        maxDifference,
        showEllipsis,
      })
    );
  }, [totalPages, currentPage, maxDifference, showEllipsis]);

  const nextPage = () => {
    const next = currentPage === totalPages ? 1 : currentPage + 1;
    handleChange(next);
  };
  const prevPage = () => {
    const prev = currentPage === 1 ? totalPages : currentPage - 1;
    handleChange(prev);
  };
  const otherPage = (page) => {
    handleChange(page);
  };

  return (
    <div className={classNames?.container || DEFAULT_CLASSNAMES.container}>
      <LeftArrowIcon onClick={prevPage} className={DEFAULT_CLASSNAMES.arrow} />
      {pages?.map((page, index) => {
        if (showEllipsis && index === 1 && page !== 2)
          return (
            <div
              key={`${page}-${index}`}
              className={classNames?.page || DEFAULT_CLASSNAMES.page}
            >
              ...
            </div>
          );
        if (
          showEllipsis &&
          index === pages?.length - 2 &&
          page !== totalPages - 1
        )
          return (
            <div
              key={`${page}-${index}`}
              className={classNames?.page || DEFAULT_CLASSNAMES.page}
            >
              ...
            </div>
          );
        return (
          <div
            onClick={() => otherPage(page)}
            key={`${page}-${index}`}
            className={`${
              currentPage === page
                ? classNames?.currentPage || DEFAULT_CLASSNAMES.currentPage
                : classNames?.page || DEFAULT_CLASSNAMES.page
            } `}
          >
            {page}
          </div>
        );
      })}
      <RightArrowIcon onClick={nextPage} className={DEFAULT_CLASSNAMES.arrow} />
    </div>
  );
};

export default PaginationBar;
